import { FC, memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Section } from 'components/general-styles/General'
import { Grid, Col } from 'components/grid'

import { tips } from './data'
import * as S from './styles'

const Tips: FC = memo(() => (
  <Section>
    <Grid col={{ phone: 1, tablet: 1 }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <S.Infos>
          <Text className="subtitle" size="caption" weight="medium" uppercase>
            Para anotar
          </Text>

          <Text as="h2" size="heading3" weight="medium">
            <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
              Dicas
            </Text>{' '}
            para quem precisa organizar as dívidas
          </Text>
        </S.Infos>

        <S.TipsList>
          {tips.map(({ id, icon: IconComponent, title, description }) => (
            <S.Card key={id}>
              <S.CardIcon>
                <IconComponent color="var(--colors-cyan-icon-default)" />
              </S.CardIcon>
              <Text as="h3" size="heading4" weight="medium">
                {title}
              </Text>
              <Text size="body2" color="var(--colors-neutral-text-weak)">
                {description}
              </Text>
            </S.Card>
          ))}
        </S.TipsList>
      </Col>
    </Grid>
  </Section>
))

Tips.displayName = 'Tips'

export default Tips
